import { clsx } from 'clsx';
import { Component, Image } from '@headless-workspace/typings';
import { GlowIcon, GlowImage } from '../../atoms';
import { PropsWithClassName, PropsWithImageTagName } from '../../props';
import { Icons } from '../../res/icons';

export type GlowSelectorImageProps = PropsWithImageTagName &
    PropsWithClassName & {
        image: Image;
        isAvailable: boolean;
        isSelected?: boolean;
        squaredShade?: boolean;
        shapeClassName?: string;
        wrapperClassName?: string;
        width?: number;
        height?: number;
    };

const DEFAULT_SIZE = 40;

export const GlowSelectorImage: Component<GlowSelectorImageProps> = ({
    image,
    isAvailable,
    isSelected = false,
    squaredShade = false,
    shapeClassName,
    wrapperClassName,
    width = DEFAULT_SIZE,
    height = DEFAULT_SIZE,
    ImageTagName,
}) => {
    const resolvedImgShape = (() => {
        if (isSelected && squaredShade) {
            return '';
        }

        if (shapeClassName != null) {
            return shapeClassName;
        }

        return squaredShade ? 'rounded-0.25' : 'rounded-infinity';
    })();

    return (
        <div
            className={clsx(
                'overflow-hidden',
                isSelected ? 'w-[1.9375rem] h-[1.9375rem]' : 'w-full h-full',
                wrapperClassName,
            )}
        >
            <GlowImage
                image={image}
                imgClassName={clsx('w-full h-full', resolvedImgShape)}
                width={width}
                height={height}
                TagName={ImageTagName}
            />
            {!isAvailable && (
                <div
                    className={clsx(
                        'absolute inset-0 flex items-end overflow-hidden',
                        squaredShade ? 'rounded-0.25' : 'rounded-infinity',
                    )}
                >
                    <GlowIcon Icon={Icons.OOSBarGroup} className={'w-full h-full'} />
                </div>
            )}
        </div>
    );
};
